import React, { useEffect, forwardRef, useImperativeHandle, useRef, useCallback, useState } from 'react'
import JoditEditor from 'jodit-react';

const buttons = [
    'undo',
    'redo',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    '|',
    'superscript',
    'subscript',
    '|',
    'align',
    '|',
    'ul',
    'ol',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'image',
    'link',
    'video',
    'table',
    '|',
    'hr',
    'eraser',
    'copyformat',
    '|',
    'selectall',
    'print',
    'find',
    'preview',
    '|',
    'source',
    '|'
    //   {
    //     name: 'insertMergeField',
    //     tooltip: 'Insert Merge Field',
    //     iconURL: 'images/merge.png',
    //     popup: (editor, current, self, close) => {
    //       function onSelected(e) {
    //         let mergeField = e.target.value;
    //         if (mergeField) {
    //           console.log(mergeField);
    //           editor.selection.insertNode(editor.create.inside.fromHTML('{{' + mergeField + '}}'));
    //         }
    //       }
    //       let divElement = editor.create.div('merge-field-popup');

    //       let labelElement = document.createElement('label');
    //       labelElement.setAttribute('class', 'merge-field-label');
    //       labelElement.text = 'Merge field: ';
    //       divElement.appendChild(labelElement);
    //       let selectElement = document.createElement('select');
    //       selectElement.setAttribute('class', 'merge-field-select');
    //       selectElement.appendChild(createOptionGroupElement(facilityMergeFields, 'Facility'));
    //       selectElement.appendChild(createOptionGroupElement(inspectionMergeFields, 'Inspection'));
    //       selectElement.onchange = onSelected;
    //       divElement.appendChild(selectElement);

    //       console.log(divElement);
    //       return divElement;
    //     },
    //   },
];

const Index = forwardRef(({ isOpen }, ref) => {
    const refData = useRef(null);
    const refEdittor = useRef(null);
    const [dataTemplate, setDataTemplate] = useState(null);

    const prepareTemplate = useCallback(async (dataTemp) => {
        setDataTemplate(dataTemp || '');
    }, [])

    useEffect(() => {
        isOpen && prepareTemplate(isOpen);
        return () => {
            setDataTemplate(null);
            refData.current = null;
        }
    }, [isOpen, prepareTemplate])

    // const config = {
    //     removeButtons: ['font', 'spellcheck', 'copyformat',
    //         'superscript', 'subscript', 'about'],
    //     height: 400,
    //     allowResizeY: false,
    // };

    const handleModelChange = useCallback((model) => {
        refData.current = model
    }, [])

    const editorConfig = {
        readonly: false,
        toolbar: true,
        spellcheck: true,
        language: 'vi',
        toolbarButtonSize: 'middle',
        toolbarAdaptive: false,
        // showCharsCounter: true,
        // showWordsCounter: true,
        // showXPathInStatusbar: false,
        // askBeforePasteHTML: true,
        // askBeforePasteFromWord: true,
        //defaultActionOnPaste: "insert_clear_html",
        buttons: buttons,
        uploader: {
            insertImageAsBase64URI: false,
        },
        height: 400,
        allowResizeY: false,
        events: {
            afterInit: (instance) => {
                refEdittor.current = instance;
            },
        },
    };

    useImperativeHandle(ref, () => ({
        getValue: () => refData.current,
        insertField: (field) => {
            refEdittor.current.selection.insertHTML(field)
        }
    }), []);

    const onBlur = useCallback((newContent) => {
        refData.current = newContent;
        return newContent;
    }, []);

    return (
        <JoditEditor
            ref={refEdittor}
            config={editorConfig}
            value={dataTemplate || ''}
            onChange={(a) => handleModelChange(a)}
            onBlur={onBlur}
        />
    )
})

export default Index
